import React, { useEffect } from "react";
const Theme = () => {
  const applyTheme = (themeKey, stylesheet) => {
    const theme1 = document.getElementById("theme1");
    if (theme1) {
      theme1.href = stylesheet;
    }
    document.body.setAttribute("data-theme", themeKey);
    localStorage.setItem("background", themeKey);
  };

  useEffect(() => {
    const storedTheme = localStorage.getItem("background") || "light";
    const legacyThemeMap = {
      0: "dark",
      1: "light",
      2: "green",
    };
    const savedTheme = legacyThemeMap[storedTheme] || storedTheme;
    const themeMap = {
      light: "assets/css/main.css",
      dark: "assets/css/main-theme3.css",
      green: "assets/css/main-theme2.css",
    };
    applyTheme(savedTheme, themeMap[savedTheme] || themeMap.light);
  }, []);

  const handlechangetheme1 = () => {
    applyTheme("light", "assets/css/main.css");
  };
  const handlechangetheme2 = () => {
    applyTheme("dark", "assets/css/main-theme3.css");
  };
  const handlechangetheme3 = () => {
    applyTheme("green", "assets/css/main-theme2.css");
  };

  return (
    <>
      <div
        className="modal fade color_modal_Section"
        id="color_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Select a color theme
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body color_body_area">
              <ul className="color_list">
                <li
                  className="material_color_option light-option"
                  data-bs-dismiss="modal"
                  onClick={handlechangetheme1}
                >
                  Light
                </li>
                <li
                  className="material_color_option dark-option"
                  data-bs-dismiss="modal"
                  onClick={handlechangetheme2}
                >
                  Dark
                </li>
                <li
                  className="material_color_option green-option"
                  data-bs-dismiss="modal"
                  onClick={handlechangetheme3}
                >
                  Green
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Theme;
